import { SafeSet } from "openchat-shared";
import {} from "./undo";
export class LocalSet {
    serialiser;
    deserialiser;
    #added;
    #removed;
    constructor(serialiser, deserialiser) {
        this.serialiser = serialiser;
        this.deserialiser = deserialiser;
        this.#added = new SafeSet(serialiser, deserialiser);
        this.#removed = new SafeSet(serialiser, deserialiser);
    }
    get added() {
        return this.#added;
    }
    get removed() {
        return this.#removed;
    }
    // only use for testing
    clear() {
        this.#added.clear();
        this.#removed.clear();
    }
    add(thing) {
        this.#added.add(thing);
        const removed = this.#removed.delete(thing);
        return () => {
            this.#added.delete(thing);
            if (removed) {
                this.#removed.add(thing);
            }
        };
    }
    remove(thing) {
        this.#removed.add(thing);
        const removed = this.#added.delete(thing);
        return () => {
            this.#removed.delete(thing);
            if (removed) {
                this.#added.add(thing);
            }
        };
    }
    apply(original) {
        if (this.#added.size === 0 && this.#removed.size === 0)
            return original;
        const merged = new SafeSet(this.serialiser, this.deserialiser);
        for (const v of original) {
            merged.add(v);
        }
        this.#added.forEach((t) => merged.add(t));
        this.#removed.forEach((t) => merged.delete(t));
        return merged;
    }
}
export class ChatLocalSet extends LocalSet {
    constructor() {
        super((k) => JSON.stringify(k), (k) => JSON.parse(String(k)));
    }
}
